import { render } from "./Coin.vue?vue&type=template&id=80a70284&bindings={\"flip\":\"setup\",\"clicked\":\"setup\",\"side\":\"setup\",\"t\":\"setup\"}"
import script from "./Coin.vue?vue&type=script&lang=js"
export * from "./Coin.vue?vue&type=script&lang=js"

import "./Coin.vue?vue&type=style&index=0&lang=css"
script.render = render

export default script